"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _typography = require("@berlitz/globals/lib/components/typography");
var _expander = _interopRequireDefault(require("@berlitz/expander"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
var _style = require("./style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BlockAccordion = function BlockAccordion(_ref) {
  var alignTitle = _ref.alignTitle,
    backgroundColor = _ref.backgroundColor,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    expandedByDefault = _ref.expandedByDefault,
    items = _ref.items,
    subtitle = _ref.subtitle,
    title = _ref.title,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'text01' : _ref$titleColor,
    initialState = _ref.initialState;
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: "lg"
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 9
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: alignTitle
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), subtitle && /*#__PURE__*/_react.default.createElement(_typography.P, {
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  })), items.map(function (_ref2) {
    var title = _ref2.title,
      content = _ref2.content;
    return /*#__PURE__*/_react.default.createElement(_expander.default, {
      key: title,
      expandedByDefault: expandedByDefault,
      initialState: initialState,
      title: /*#__PURE__*/_react.default.createElement(_style.Title, {
        color: titleColor,
        disableMargin: true,
        dangerouslySetInnerHTML: {
          __html: title
        }
      }),
      icon: true
    }, /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "sm"
    }), _htmlCheck.default.test(content) ? /*#__PURE__*/_react.default.createElement(_typography.RichText, {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }) : /*#__PURE__*/_react.default.createElement(_typography.P, {
      disableMargin: true
    }, content), /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "lg"
    }));
  })))));
};
BlockAccordion.defaultProps = {
  alignTitle: 'center',
  items: []
};
var _default = BlockAccordion;
exports.default = _default;